import React, { useState, useRef, useEffect } from 'react';
import { Icon16Clear, Icon16ChevronLeft } from '@vkontakte/icons';
import {AdaptivityContext} from "../../assets/constants";
import './AlphabetFilter.css';

const AlphabetFilter = ({ letters, onLetterClick, activeLetter }) => {
    const [expandedLetter, setExpandedLetter] = useState(null);
    const containerRef = useRef(null);
    const touchStartY = useRef(0);

    // Сбрасываем expandedLetter когда activeLetter становится пустым
    useEffect(() => {
        if (activeLetter === '') {
            setExpandedLetter(null);
        }
    }, [activeLetter]);

    // Используем нативные event listeners с { passive: false } чтобы можно было вызвать preventDefault
    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        const handleTouchStart = (e) => {
            touchStartY.current = e.touches[0].clientY;
            e.stopPropagation();
        };

        const handleTouchMove = (e) => {
            e.stopPropagation();
            if (e.cancelable) {
                e.preventDefault();
            }
            
            // Делаем скролл вручную
            const touchY = e.touches[0].clientY;
            const deltaY = touchStartY.current - touchY;
            container.scrollTop += deltaY;
            touchStartY.current = touchY;
        };

        const handleTouchEnd = (e) => {
            e.stopPropagation();
        };

        container.addEventListener('touchstart', handleTouchStart, { passive: false });
        container.addEventListener('touchmove', handleTouchMove, { passive: false });
        container.addEventListener('touchend', handleTouchEnd, { passive: false });

        return () => {
            container.removeEventListener('touchstart', handleTouchStart);
            container.removeEventListener('touchmove', handleTouchMove);
            container.removeEventListener('touchend', handleTouchEnd);
        };
    }, []);

    if (!letters || letters.length === 0) {
        return null;
    }

    const handleLetterClick = (letterObj) => {
        if (letterObj.variants && letterObj.variants.length > 0) {
            setExpandedLetter(expandedLetter === letterObj.letter ? null : letterObj.letter);

        } else {
            onLetterClick(letterObj.letter);
        }
    };

    const handleVariantClick = (variant) => {
        onLetterClick(variant);
    };

    const handleReset = () => {
        setExpandedLetter(null);
        onLetterClick('');
    };

    const isVariantActive = (variant) => activeLetter === variant;
    const isLetterActive = (letterObj) => {
        if (!activeLetter) return false;
        return letterObj.variants?.some(v => v === activeLetter) || letterObj.letter === activeLetter;
    };

    return (
        <div 
            ref={containerRef}
            className="alphabet-filter"
            style={{
                minWidth: AdaptivityContext.isMobile? '30px': '50px',
                maxHeight: AdaptivityContext.isMobile?'87%':'90%'
            }}
        >
            {(activeLetter || expandedLetter) && (
                <div
                    key="reset"
                    onClick={ handleReset}
                    style={{
                        textAlign: 'center',
                        padding: '5px 2px 5px 7px',
                        cursor: 'pointer',
                        color: '#e64646'
                    }}
                    title="Сбросить фильтр"
                >
                    <Icon16Clear />
                </div>
            )}

            {expandedLetter ? (
                // Показываем варианты выбранной буквы
                letters
                    .find(el => el.letter === expandedLetter)
                    ?.variants?.map((variant, index) => (
                        <div
                            key={variant + index}
                            onClick={() => handleVariantClick(variant)}
                            style={{
                                textAlign: 'center',
                                padding: '7px 2px 4px 7px',
                                cursor: 'pointer',
                                fontWeight: isVariantActive(variant) ? 'bold' : 'normal',
                                color: isVariantActive(variant) ? '#3f8ae0' : 'inherit',
                                fontSize: '12px'
                            }}
                        >
                            {variant}
                        </div>
                    ))
            ) : (
                // Показываем буквы
                letters.map((el, index) => (
                    <div
                        key={el.letter + index}
                        onClick={() => handleLetterClick(el)}
                        style={{
                            textAlign: 'center',
                            padding: '7px 2px 4px 7px',
                            cursor: 'pointer',
                            fontWeight: isLetterActive(el) ? 'bold' : 'normal',
                            color: isLetterActive(el) ? '#3f8ae0' : 'inherit'
                        }}
                    >
                        {el.letter}
                    </div>
                ))
            )}
        </div>
    );
};

export default AlphabetFilter;

